import * as React from 'react';
import { getTheme } from 'office-ui-fabric-react';
import { jsx as _jsx } from "react/jsx-runtime";
const theme = getTheme();
export const Badge = _ref => {
  let {
    invertStyle = false,
    color = theme.palette.themePrimary,
    children
  } = _ref;
  const badgeStyle = invertStyle ? {
    color: color,
    padding: '1px 8px 1px 8px',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: theme.palette.white
  } : {
    color: theme.palette.white,
    padding: '1px 8px 1px 8px',
    borderWidth: 1,
    borderStyle: 'solid',
    backgroundColor: color
  };
  return /*#__PURE__*/_jsx("span", {
    style: badgeStyle,
    children: children
  });
};